import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(ISettingEntry) {
    (function(SettingType) {
        SettingType["SETTING_TYPE_UNKNOWN"] = "SETTING_TYPE_UNKNOWN";
        SettingType["CONFIGURATION"] = "CONFIGURATION";
        SettingType["EXPERIMENT"] = "EXPERIMENT";
        SettingType["FEATURE_TOGGLE"] = "FEATURE_TOGGLE";
    })(ISettingEntry.SettingType || (ISettingEntry.SettingType = {}));
    (function(SerializeToClient) {
        SerializeToClient["SERIALIZE_TO_CLIENT_UNKNOWN"] = "SERIALIZE_TO_CLIENT_UNKNOWN";
        /**
     * Retailer web portal
     */ SerializeToClient["RETAILER"] = "RETAILER";
        /**
     * Retailer web portal, but only if the auth'd user is logged in
     */ SerializeToClient["LOGGED_IN_RETAILER"] = "LOGGED_IN_RETAILER";
        /**
     * Legacy neighborhood retailer portal
     * @deprecated
     */ SerializeToClient["RETAILER_PORTAL"] = "RETAILER_PORTAL";
        /**
     * Brand web portal
     */ SerializeToClient["MAKER"] = "MAKER";
        /**
     * Legacy neighborhood consumer portal
     * @deprecated
     */ SerializeToClient["CONSUMER"] = "CONSUMER";
        /**
     * admin2 web
     */ SerializeToClient["ADMIN"] = "ADMIN";
        /**
     * Help center web
     */ SerializeToClient["HELP_CENTER"] = "HELP_CENTER";
        /**
     * Brand widget web
     */ SerializeToClient["BRAND_WIDGET"] = "BRAND_WIDGET";
        /**
     * Retailer android app
     */ SerializeToClient["RETAILER_ANDROID"] = "RETAILER_ANDROID";
        /**
     * Retailer ios app
     */ SerializeToClient["RETAILER_IOS"] = "RETAILER_IOS";
        /**
     * Brand android app
     */ SerializeToClient["BRAND_ANDROID"] = "BRAND_ANDROID";
        /**
     * Brand ios app
     */ SerializeToClient["BRAND_IOS"] = "BRAND_IOS";
        /**
     * Visitor (logged-out) React app.
     * @deprecated
     */ SerializeToClient["VISITOR_WEB"] = "VISITOR_WEB";
        /**
     * Shopify Sales Channel app
     */ SerializeToClient["SHOPIFY_SALES_CHANNEL"] = "SHOPIFY_SALES_CHANNEL";
        /**
     * hotjar for brand web
     */ SerializeToClient["HOTJAR_BRAND"] = "HOTJAR_BRAND";
        /**
     * hotjar for retailer web
     */ SerializeToClient["HOTJAR_RETAILER"] = "HOTJAR_RETAILER";
        /**
     * hotjar for help center
     */ SerializeToClient["HOTJAR_HELP_CENTER"] = "HOTJAR_HELP_CENTER";
        /**
     * Retailer Shopify Integration app
     */ SerializeToClient["RETAILER_SHOPIFY_INTEGRATION"] = "RETAILER_SHOPIFY_INTEGRATION";
        /**
     * Edge server
     */ SerializeToClient["EDGE"] = "EDGE";
        /**
     * Shopify Product Sourcing app (will replace RETAILER_SHOPIFY_INTEGRATION)
     */ SerializeToClient["SHOPIFY_PRODUCT_SOURCING"] = "SHOPIFY_PRODUCT_SOURCING";
        /**
     * Head tags for retailer web
     */ SerializeToClient["RETAILER_HEAD_TAGS"] = "RETAILER_HEAD_TAGS";
        /**
     * Our beloved dev.faire.team
     */ SerializeToClient["DEV_PORTAL"] = "DEV_PORTAL";
        /**
     * Our own PR bot
     */ SerializeToClient["PR_BOT"] = "PR_BOT";
    })(ISettingEntry.SerializeToClient || (ISettingEntry.SerializeToClient = {}));
    ISettingEntry.build = function(partial) {
        return _object_spread({
            serialize_to_pages: [],
            monitor_client_performance: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(ISettingEntry || (ISettingEntry = {}));
export var ISettingEntry;
